module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-allorderbill"
  }, [_c('nav', {
    staticClass: "edi-nav"
  }, [_c('div', [_vm._v("餐企订单")]), _vm._v(" "), (_vm.navEditShow) ? _c('div', {
    staticClass: "edi-nav-edit",
    on: {
      "click": _vm.navEdit
    }
  }, [_vm._v(_vm._s(_vm.editContent))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "common-scroll",
    staticStyle: {
      "bottom": "0"
    },
    attrs: {
      "id": "common-scroll"
    },
    on: {
      "scroll": _vm.refresh
    }
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "ui-search-input",
    class: {
      'ui-search-input2': _vm.filterShow, 'ui-search-input1': !_vm.filterShow
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterSearch.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.filterShow) ? _c('a', {
    staticClass: "ui-filter-icon",
    on: {
      "click": _vm.move
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "ui-listview",
    style: (_vm.editShow === true ? 'padding-bottom:3em' : 'padding-bottom:0')
  }, _vm._l((_vm.orderBills), function(orderBill, index) {
    return _c('li', [_c('p', {
      staticClass: "allorderbill-list-p"
    }, [_vm._v(_vm._s(orderBill.restaurant_name) + "\n\t\t\t\t\t\t"), (orderBill.bill_state == 10) ? _c('span', {
      staticClass: "grey-font"
    }, [(orderBill.urgent_flag == 1) ? _c('i', {
      staticClass: "tips-flag"
    }, [_vm._v("加急")]) : _vm._e(), _vm._v("未处理\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (orderBill.bill_state == 11) ? _c('span', {
      staticClass: "aqua-font"
    }, [(orderBill.urgent_flag == 1) ? _c('i', {
      staticClass: "tips-flag"
    }, [_vm._v("加急")]) : _vm._e(), _vm._v("待发货\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (orderBill.bill_state == 12) ? _c('span', {
      staticClass: "orange-font"
    }, [(orderBill.urgent_flag == 1) ? _c('i', {
      staticClass: "tips-flag"
    }, [_vm._v("加急")]) : _vm._e(), _vm._v("已发货\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (orderBill.bill_state == 13) ? _c('span', {
      staticClass: "ink-font"
    }, [(orderBill.urgent_flag == 1) ? _c('i', {
      staticClass: "tips-flag"
    }, [_vm._v("加急")]) : _vm._e(), _vm._v("已收货\n\t\t\t\t\t\t\t"), _c('span', {
      staticStyle: {
        "color": "#f00",
        "font-size": "1em",
        "margin-left": "12px"
      }
    }, [_vm._v("待确认")])]) : _vm._e(), _vm._v(" "), (orderBill.bill_state == 14 || orderBill.bill_state == 15 || orderBill.bill_state == 16 || orderBill.bill_state == 17) ? _c('span', {
      staticClass: "ink-font"
    }, [(orderBill.urgent_flag == 1) ? _c('i', {
      staticClass: "tips-flag"
    }, [_vm._v("加急")]) : _vm._e(), _vm._v("已收货\n\t\t\t\t\t\t\t"), _c('span', {
      staticStyle: {
        "color": "#25bf7a",
        "font-size": "1em",
        "margin-left": "12px"
      }
    }, [_vm._v("已确认")])]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "bill-state-inter"
    }, [_vm._v(" ")]), _vm._v(" "), (orderBill.weight_state == 0 && _vm.showDzcScaleappFlag) ? _c('span', {
      staticClass: "grey-font"
    }, [_vm._v("未称重")]) : _vm._e(), _vm._v(" "), (orderBill.weight_state == 1 && _vm.showDzcScaleappFlag) ? _c('span', {
      staticClass: "aqua-font"
    }, [_vm._v("待称重")]) : _vm._e(), _vm._v(" "), (orderBill.weight_state == 2 && _vm.showDzcScaleappFlag) ? _c('span', {
      staticClass: "ink-font"
    }, [_vm._v("已称重")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "allorderbill-detail-info"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editShow),
        expression: "editShow"
      }],
      staticClass: "allorderbill-checkbox"
    }, [_c('input', {
      staticClass: "selectAll",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.checkedAllList.indexOf(orderBill.id) >= 0
      },
      on: {
        "click": function($event) {
          return _vm.checkedOne(orderBill.id)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "allorderbill-detail-ul"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/detail-bill',
          query: {
            bill_id: orderBill.id
          }
        }
      }
    }, [_c('ul', {
      staticClass: "ui-detail-listview"
    }, [_c('li', [_vm._v("单号：" + _vm._s(orderBill.trans_bill_no))]), _vm._v(" "), _c('li', [_vm._v("订货日期：" + _vm._s(_vm.dateCut(orderBill.from_date)))]), _vm._v(" "), _c('li', [_vm._v("订货：" + _vm._s(orderBill.from_organ_name))]), _vm._v(" "), _c('li', [_vm._v("收货日期：" + _vm._s(_vm.dateCut(orderBill.to_date)))]), _vm._v(" "), _c('li', {
      staticClass: "line2Row"
    }, [_vm._v("送往：" + _vm._s(orderBill.to_organ_name))]), _vm._v(" "), _c('li', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!orderBill.hiddenTax),
        expression: "!orderBill.hiddenTax"
      }]
    }, [_vm._v("含税")]), _vm._v("金额：" + _vm._s(_vm._f("toDecimal")(orderBill.sum_money_send)) + " 元")]), _vm._v(" "), (orderBill.original_bill_id) ? _c('li', {
      staticClass: "bill-third-no"
    }, [_vm._v("第三方单号：" + _vm._s(orderBill.original_bill_id))]) : _vm._e()])])], 1)]), _vm._v(" "), _c('p', {
      staticClass: "allorderbill-total-p"
    }, [_vm._v("共"), _c('strong', [_vm._v(_vm._s(orderBill.detail_num))]), _vm._v("种品项")])])
  }), 0)]), _vm._v(" "), _c('refresh', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show),
      expression: "!show"
    }],
    attrs: {
      "cls": _vm.cls,
      "font": _vm.font
    }
  }), _vm._v(" "), _c('mid-ware', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.midware),
      expression: "midware"
    }],
    attrs: {
      "icon": _vm.icon,
      "midFont": _vm.midFont
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editFootShow),
      expression: "editFootShow"
    }],
    staticClass: "allorderbill-footer"
  }, [_c('div', {
    staticClass: "allorderbill-info-left"
  }, [_c('span', {
    staticClass: "allorderbill-check-all",
    on: {
      "click": _vm.checkedAll
    }
  }, [_vm._v(_vm._s(_vm.checkAllContent))])]), _vm._v(" "), _c('div', {
    staticClass: "allorderbill-info-right"
  }, [(this.billState == 10) ? _c('div', {
    staticClass: "allorderbill-batch allorderbill-agree",
    on: {
      "click": function($event) {
        return _vm.batch('同意')
      }
    }
  }, [_vm._v("\n\t\t\t\t批量同意\n\t\t\t")]) : _vm._e(), _vm._v(" "), (this.billState == 11) ? _c('div', {
    staticClass: "allorderbill-batch allorderbill-agree",
    on: {
      "click": function($event) {
        return _vm.batch('发货')
      }
    }
  }, [_vm._v("\n\t\t\t\t批量发货\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "allorderbill-batch allorderbill-return",
    on: {
      "click": function($event) {
        return _vm.batch('退回')
      }
    }
  }, [_vm._v("\n\t\t\t\t批量退回\n\t\t\t")])])]), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('tipsAuto-hasMiddleStyle', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont,
      "tipsAutoIco": _vm.tipsAutoIco
    }
  }), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tips),
      expression: "tips"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  }), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipss),
      expression: "tipss"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatusB
    }
  }), _vm._v(" "), (_vm.filterShow) ? _c('bill-filter', {
    ref: "billFilterOpen",
    attrs: {
      "filterBillFont": _vm.queryData.bill_font,
      "filterBillState": _vm.queryData.bill_state,
      "filterSort": _vm.sort,
      "filterSortFont": _vm.sortFont,
      "filterStarDate": _vm.queryData.start_date,
      "filterEndDate": _vm.queryData.end_date
    },
    on: {
      "confirm": _vm.backValue
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-625c1669!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AllOrderBill.vue
// module id = 580
// module chunks = 1